<template>
    <div class="share-view">
        <QuizHeader/>

        <div class="share-view__body">
            <div class="share">
                <h1><span class="bigger">Share your result!</span></h1>

                <img :src="getImgUrl(outcome.share_image_url)" class="share__image">

                <div class="share-options">
                    <details class="share-toggle">
                        <summary class="share-action">
                            <div class="share-action__content">
                                <div class="share-action__icon">
                                    <img src="@/images/social/instagram.svg" />
                                </div>

                                Instagram
                            </div>
                        </summary>

                        <div class="share-toggle__content">
                            <p><strong>Step 1:</strong> download the above graphic to your phone</p>
                            <p><strong>Step 2:</strong> tap here to open and share to your story</p>

                            <a href="instagram://story-camera" class="button button--ghost">Open Instagram app</a>
                        </div>
                    </details>

                    <a :href="facebook_share_url" @click.capture="openPopup" class="share-action">
                        <div class="share-action__content">
                            <div class="share-action__icon">
                                <img src="@/images/social/facebook.svg" />
                            </div>

                            Facebook
                        </div>
                    </a>

                    <a :href="twitter_share_url" @click.capture="openPopup" class="share-action">
                        <div class="share-action__content">
                            <div class="share-action__icon">
                                <img src="@/images/social/twitter.svg" />
                            </div>

                            Twitter
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import QuizHeader from "@/components/QuizHeader";

export default {
    name: "QuizPage",
    components: {
        QuizHeader
    },
    data() {
        return {
            quiz_data: require('@/json/quiz.json'),
            outcome: null,
            facebook_share_url: '',
            twitter_share_url: ''
        }
    },
    created() {
        this.outcome = this.quiz_data.outcomes[this.$route.params.outcome];

        let share_url = location.protocol + "//" + location.hostname;

        let share_text = 'I’m a '+this.outcome.noun+' – find out your ice cream personality and enter for the chance to win a LIFETIME supply of ice cream';

        let facebook_url = new URL("https://www.facebook.com/sharer/sharer.php");
        facebook_url.searchParams.append('u', share_url);
        facebook_url.searchParams.append('quote', share_text);
        facebook_url.searchParams.append('hashtag', '#mymackiesmoment');

        this.facebook_share_url = facebook_url;

        let twitter_url = new URL("https://twitter.com/intent/tweet");
        twitter_url.searchParams.append('url', share_url);
        twitter_url.searchParams.append('text', share_text);
        twitter_url.searchParams.append('hashtags', 'mymackiesmoment');
        this.twitter_share_url = twitter_url;
    },
    methods: {
        openPopup(e) {
            e.preventDefault();
            window.open(e.target.href, 'sharer', 'height=400,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0')
        }
    }
}
</script>

<style scoped lang="stylus">
.share-view {
    display: flex;
    flex-direction: column;
    flex: 1;

    &__body {
        display: flex;
        flex: 1;
        background: brand-blue;
        color: white;
        text-align: center;
        flex-direction column;
        align-items: center;
        padding: calc(5% + 1em);
    }
}

.share {
    max-width: 30em;

    &__image {
        width: 100%;
        display: block;
    }
}

.share-options {
    text-align: left;
    margin-top: 1em;
}

.share-action {
    padding: 0.5em 0.8rem
    font-size: 1.5em;
    text-decoration none;
    color: inherit;
    display: flex;
    justify-content space-between;
    align-items center;
    cursor pointer;
    border-radius 0.3em;

    * {
        pointer-events: none
    }

    &__content {
        display: flex;
        align-items center;
    }

    &__icon {
        width: 3.5rem;

        img {
            height: 1.4em;
            display: block;
        }
    }

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }

    &::marker,
    &::-webkit-details-marker{
        display: none;
    }

    &:after {
        content: "›";
        font-size: 1.4em;
        line-height: 1;
        margin-right: 0.2em
    }
}

.share-toggle {
    appearance none;

    ::marker {
        display: none;
    }

    &[open] {
        .share-action {
            &:after {
                transform: rotate(90deg);
            }

        }
    }

    &__content {
        margin-bottom: 2em;
        padding-top: 0.4em;
        padding-left: 1rem;

        @media (min-width: 400px) {
            padding-left: 4.4rem;
        }
    }

    p {
        font-weight: normal;
    }
}

</style>